import styled, { css } from 'styled-components';
import { size } from '../../../../../styled/layout/helpers';
import Text from '../../../../../styled/Text';
import { theme } from '../../../../../styled/layout/theme';

export const LeadTimeSection = styled.div`
  &.hidden {
    display: none;
  }

  ${theme.screens.LtSm} {
    flex-grow: 1;
  }
`;

export const ToggleContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${size(1)};
  ${theme.screens.LtMd} {
    justify-content: space-between;
    flex-direction: row-reverse;
  }
`;

export const TextContainer = styled.div`
  display: flex;
  ${theme.screens.LtSm} {
    flex-direction: column;
  }
`;

export const Wrapper = styled.div`
  align-items: center;
  display: flex;

  ${theme.screens.LtMd} {
    display: block;
  }
`;

const Divider = css`
  border-left: 1px solid ${theme.colors.border.main};
  bottom: 0;
  content: '';
  position: absolute;
  top: 0;
  margin-left: ${size(1)};
  left: 100%;

  ${theme.screens.LtSm} {
    display: none;
  }
`;

const TitleDivider = css`
  border-left: 1px solid ${theme.colors.bg.infoActive};
  bottom: 0;
  content: '';
  margin: 0 ${size(2)};
  ${theme.screens.LtSm} {
    display: none;
  }
`;

export const Selections = styled.div`
  display: flex;

  ${theme.screens.LtSm} {
    display: block;
  }
`;

export const DeliveryTime = styled.div`
  margin-left: ${size(3)};

  ${theme.screens.LtSm} {
    padding-top: ${size(1)};
    margin-left: 0;
  }
`;

export const Store = styled.div`
  position: relative;
  margin-left: ${size(2)};

  &:after {
    ${Divider};
  }

  ${theme.screens.LtMd} {
    margin-left: 0;
  }

  ${theme.screens.LtSm} {
    margin-left: 0;
    padding: ${size(1)} 0;
    border-bottom: 1px solid #e6e6e6;
  }
`;

export const Pitch = styled.div`
  display: flex;
  align-items: center;
  margin-left: ${size(1)};

  & .symbol {
    margin-left: ${size(1)};
  }

  ${theme.screens.LtSm} {
    align-items: center;
    margin-left: 0;
  }
`;

export const Title = styled(Text)`
  font-size: 16px;
  font-weight: 600;
  &::after {
    ${theme.screens.Md} {
      ${TitleDivider}
    }
  }
`;

export const Description = styled(Text)`
  font-size: 16px;
  font-weight: 400;
`;
